import { CrudService } from "@/services/crudService";

const crud = new CrudService();
const RESOURCE_URL = `/cztextblocks`;

export interface Testimonial {
  id: number;
  image: string;
  title: string;
  smallText: string;
  text: string;
}

export const testimonialService = {
  async getTestimonials() {
    return await crud.httpGet(`${RESOURCE_URL}/list-testimonials`);
  },
};
